<ng-container [ngSwitch]="mode">
  <ng-container *ngSwitchCase="LabelMode.DEFAULT" [ngTemplateOutlet]="default"></ng-container>
  <ng-container *ngSwitchCase="LabelMode.INLINE" [ngTemplateOutlet]="inline"></ng-container>
  <ng-container *ngSwitchCase="LabelMode.NO_LABEL" [ngTemplateOutlet]="input"></ng-container>
</ng-container>

<ng-template #input>
  <textarea #textareaBox class="form-control" [ngClass]="{ 'is-invalid': isError }" [id]="name" [name]="name" [placeholder]="placeholder | translate" [formControl]="form" [rows]="rows"></textarea>
</ng-template>

<ng-template #default>
  <div class="form-group" [ngClass]="classes">
    <label [for]="name">{{ label | translate }} <ng-container [ngTemplateOutlet]="subLabel"></ng-container></label>
    <ng-container [ngTemplateOutlet]="input"></ng-container>
    <ng-container [ngTemplateOutlet]="error"></ng-container>
  </div>
</ng-template>

<ng-template #inline>
  <div class="form-group form-group-inline">
    <label [for]="name">{{ label | translate }} <ng-container [ngTemplateOutlet]="subLabel"></ng-container></label>
    <ng-container [ngTemplateOutlet]="input"></ng-container>
    <ng-container [ngTemplateOutlet]="error"></ng-container>
  </div>
</ng-template>

<ng-template #subLabel>
  <span class="text-danger" *ngIf="addonLabel != '' && addonLabel != '*'">({{ addonLabel | translate }})</span>
  <span class="text-danger" *ngIf="addonLabel != '' && addonLabel === '*'">{{ addonLabel | translate }}</span>
</ng-template>

<ng-template #error>
  <span class="error" *ngIf="isError && showErrorMessage">{{ errorMessage | translate }}</span>
</ng-template>
